import { tiktokPixelService } from '@/services'
import { SHARED_LOADING, SHARED_UNLOADING } from '@/store/shared.module'

//define module name
const MODULE_NAME = 'tiktokPixel/'

const A_GET_TIKTOK_PIXELS = 'getTiktokPixels'

export const GET_TIKTOK_PIXEL = MODULE_NAME + A_GET_TIKTOK_PIXELS

const M_SET_TIKTOK_PIXELS = 'setTiktokPixels'

const state = {
  tiktokPixels: {
    complete: false,
    success: false,
    message: '',
    data: null
  }
}

const getters = {}

const actions = {
  [A_GET_TIKTOK_PIXELS]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })

    return tiktokPixelService.getTiktokPixels().then(
      data => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_TIKTOK_PIXELS, { result: data })
        return data
      },
      error => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_TIKTOK_PIXELS, { result: error })
        return error
      }
    )
  }
}

const mutations = {
  [M_SET_TIKTOK_PIXELS](state, { result }) {
    state.tiktokPixels = {
      complete: true,
      success: result.status === 'success',
      message: result.message || '',
      data: result.data || null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
